import React from 'react';
import { GiftIcon } from 'lucide-react';
type Bonus = {
  number: string;
  title: string;
  price: string;
  body: string;
  image: string;
  alt: string;
};
const bonuses: Bonus[] = [{
  number: 'Bonus 01',
  title: 'The Luxury Client Email Swipe File',
  price: '$19',
  body: 'Never stare at a blank email again. Copy-paste templates for lead follow-ups, payment reminders, communication boundaries, scope changes and post-wedding messages — all in a premium tone.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/a62bd7b5-e796-4e2c-bd45-47c7187977db.jpg',
  alt: 'Laptop with an email draft on an ivory desk with gold pen and eucalyptus'
}, {
  number: 'Bonus 02',
  title: 'The Wedding Planner Quick-Start Checklist',
  price: '$9',
  body: 'Your first 48 hours with the system, mapped: what to read first, what to customize, what to implement. Zero overwhelm.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/d931515f-29e9-4b22-a433-2f4b7ff1dc47.jpg',
  alt: 'Printed checklist card with gold checkmarks, fountain pen and small clock'
}, {
  number: 'Bonus 03',
  title: 'The Premium Client Welcome Pack Template',
  price: '$17',
  body: 'Look high-end from the very first touchpoint: welcome letter, communication guidelines, next steps and the couple’s initial checklist — ready to brand as yours.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/8618da96-9544-4395-b61e-6715ac262ffc.jpg',
  alt: 'Ivory welcome packet with letterpress card, vellum envelope and gold wax seal'
}, {
  number: 'Bonus 04',
  title: 'The Vendor Follow-Up Script Kit',
  price: '$15',
  body: 'Chase quotes, confirm availability and close final details without sounding pushy — or desperate.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/8457ba01-dccd-45ee-9677-89bb9d1c94cf.jpg',
  alt: 'Smartphone with a message thread beside a printed vendor contact sheet'
}, {
  number: 'Bonus 05',
  title: 'The Wedding Day Pocket Command Sheet',
  price: '$19',
  body: 'A printable field tool for the big day: key contacts, simplified timeline, emergency checklist and fast-response protocols. On the wedding day, this lives in your hand.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/bdf1459e-343c-43ec-af1d-5482a0375647.jpg',
  alt: 'Pocket command sheet on an ivory clipboard with gold clip, earpiece and pen'
}];
export function Bonuses() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-26" data-mp="2xrxm3one1d4b">
      <div className="mx-auto max-w-6xl px-5" data-id="element-27" data-mp="32sv5g4k4wd7e">
        <div className="text-center" data-id="element-28" data-mp="32r0jcmx4mf1q">
          <span className="inline-flex items-center gap-2 border border-gold-soft bg-gold-tint px-4 py-2 text-[10px] uppercase tracking-[0.22em] text-ink-soft" data-id="element-29" data-mp="37kd0yd3e1lkz">
            <GiftIcon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-30" data-mp="2a2lf8vfj9h56" />
            5 Pro bonuses included free
          </span>
          <h2 className="mt-8 font-serif text-3xl sm:text-5xl text-ink" data-id="element-31" data-mp="27k9mhace24fi">
            Total value: $79 <span className="text-gold-dark" data-id="element-32" data-mp="22kewd90ftivi">→ free</span> with your
            Wedding Pro OS
          </h2>
          <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-33" data-mp="1xl2aorlayhui" />
        </div>

        <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-34" data-mp="1tkrs8fgbpyyr">
          {bonuses.map(bonus => <li key={bonus.number} className="flex flex-col overflow-hidden border border-gold-soft/70 bg-ivory" data-id="element-35" data-mp="1olf5rvtd6twp">
              <img src={bonus.image} alt={bonus.alt} className="h-44 w-full object-cover" loading="lazy" data-id="element-36" data-mp="1jsm2zdhghvn9" />
              <div className="flex flex-1 flex-col p-7" data-id="element-37" data-mp="19y2fjtsm3zzz">
                <div className="flex items-center justify-between gap-3" data-id="element-38" data-mp="15uxi45ne2oi7">
                  <span className="text-[10px] uppercase tracking-[0.24em] text-gold-dark" data-id="element-39" data-mp="10vt9bg4dmsse">
                    {bonus.number}
                  </span>
                  <span className="inline-flex items-center gap-2 text-xs" data-id="element-40" data-mp="30ycaguo3f8im">
                    <s className="text-ink-muted" data-id="element-41" data-mp="34ycq2imxhpr9">{bonus.price}</s>
                    <span className="bg-ink px-2.5 py-1 text-[10px] uppercase tracking-[0.16em] text-gold" data-id="element-42" data-mp="2r897q2r66g73">
                      Free
                    </span>
                  </span>
                </div>
                <h3 className="mt-4 font-serif text-xl leading-snug text-ink" data-id="element-43" data-mp="2h9bnhc0s18tw">
                  {bonus.title}
                </h3>
                <p className="mt-4 flex-1 text-[15px] leading-relaxed text-ink-soft" data-id="element-44" data-mp="2m9pm63ghn6f9">
                  {bonus.body}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}